<template>
  <div style="width:100%;height: 100%;">
    <div id="container-show" style="width:100%;height: 100%;"></div>
  </div>
</template>

<script>
import { Share,DeleteLocation,RefreshLeft,DocumentChecked,Location} from '@element-plus/icons-vue'
import { defineComponent } from "vue";
export default defineComponent({
  data(){
    return {
      Share,DeleteLocation,RefreshLeft,DocumentChecked,Location,

      searchValue:'',

      map: null,
      mouseTool: null,
      polyType: {
        strokeColor: "#E47878",
        strokeOpacity: 1,
        strokeWeight: 4,
        strokeOpacity: 0.2,
        fillColor: "#1791fc",
        fillOpacity: 0.4,
        // 线样式还支持 'dashed'
        strokeStyle: "solid"
        // strokeStyle是dashed时有效
        // strokeDasharray: [30,10],
      },
      polygonList: [],
      savedPolygon: []
    }
  },
  props: {
    //电子围栏信息参数
    electronicFence: String,
    
  },
  watch: {
    electronicFence: {
      handler(val) {
        this.initMap();
      },
      deep: true
    },
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
    
    
  },
  methods: {
    
    initMap() {
      let that = this
      let citysearch = new AMap.CitySearch();
      //  获取用户IP，返回当前城市
      citysearch.getLocalCity(function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          if (result && result.city && result.bounds) {
            let cityInfo = result.city;
            that.markLocation(cityInfo);
          }
        } else {
          alert(result.info)
        }
      })
    },
    markLocation(address) {
      if(!address){
        return false;
      }
      let that = this
      AMap.plugin('AMap.Geocoder', function () {
        var geocoder = new AMap.Geocoder();
        geocoder.getLocation(address, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            
            let savedPolygon = JSON.parse(that.electronicFence);
            let permission = savedPolygon[0].path[0];
            
            // 经纬度                      
            // var lng = result.geocodes[0].location.lng;
            // var lat = result.geocodes[0].location.lat;
            var lng = permission[0];
            var lat = permission[1];
            // 地图实例
            that.map = new AMap.Map("container-show", {
              resizeEnable: true, // 允许缩放
              center: [lng, lat], // 设置地图的中心点
              zoom: 15 // 设置地图的缩放级别，0 - 20
            });
            that.redrawPolygon();
          } else {
            console.log('定位失败！');
          }
        });
        
      });
      
    },
   

   
    // 用保存的数据重新绘制多边形并添加事件
    redrawPolygon() {
      if(this.electronicFence){
        let savedPolygon = JSON.parse(this.electronicFence);
        console.log("重绘多边形数据", savedPolygon);
        if (savedPolygon == null) return;
        for (let i = 0; i < savedPolygon.length; i++) {
          var polygon = new AMap.Polygon(savedPolygon[i]);
          this.map.add(polygon);
        }
      }
    },

  }
})
</script>
<style lang="scss" scoped>
  .input-card{
    display: flex;
    position: absolute;
    top: 45px;
    left: 10px;
    padding: 10px;
    background: white;
    box-shadow: 2px 2px 5px #7a7a7a;
    width: 355px;
    justify-content: space-between;
  }
  .search-address{
    display: flex;
    position: absolute;
    top: 45px;
    left: 395px;
    padding: 10px;
    background: white;
    box-shadow: 2px 2px 5px #7a7a7a;
    width: 315px;
    justify-content: space-between;
  }
</style>